import * as React from 'react';
import { observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';

import { ApiUrls } from '@app/AppConstants/ApiUrls';
import { MonthlyTypeModel } from '@app/Models/WebApiModels';

import ApiService from '@app/Services/ApiService';

import ReactSelect, { ReactSelectValue, ReactSelectSize } from '@app/Components/ReactSelect';
import { applyDecorators } from "@app/Helpers/Decorator";

type MonthlyPickerProps = {
    clearable?: boolean;
    multi?: boolean;
    value?: string | null;
    onSelect?: (value: string | null) => void;
    selectSize?: ReactSelectSize;
};

@observer
export default class MonthlyPicker extends React.Component<MonthlyPickerProps> {
    private _store: MonthlyPickerStore;

    constructor(props: MonthlyPickerProps) {
        super(props);
        applyDecorators(this);
        this._store = new MonthlyPickerStore();
    }

    componentDidMount(): void {
        void this._store.loadMonthlyTypes();
    }

    render() {
        const { clearable, selectSize, multi, value } = this.props;
        const { options } = this._store;
        return <ReactSelect placeholder="None" options={options} multi={multi} value={value} isClearable={clearable} selectSize={selectSize} onSelect={this._onChangeHandler} />;
    }

    @action.bound
    private _onChangeHandler(value: ReactSelectValue) {
        this.props.onSelect && this.props.onSelect(value);
    }
}

class MonthlyPickerStore {
    @observable monthlyTypes: MonthlyTypeModel[] = [];

    constructor() {
        applyDecorators(this);
    }

    @action
    public async loadMonthlyTypes() {
        const monthlyTypes = await ApiService.getData(ApiUrls.MonthDutyTypeUrl);
        this.monthlyTypes = monthlyTypes.data || [];
    }

    @computed
    public get options() {
        return this.monthlyTypes.map((type) => {
            return { value: `${type.value}`, label: type.name || '' };
        });
    }
}
